export default __webpack_public_path__ + "static/media/caroussel-1.54160f49.png";